module.exports = __webpack_public_path__ + "static/media/unlink_on.c28bd142.png";